import './PageSpinner.css';

interface PageSpinnerProps {
  minHeight?: string;
}

export function PageSpinner({ minHeight = '200px' }: PageSpinnerProps) {
  return (
    <div className="page-spinner" style={{ minHeight }} aria-busy="true">
      <div className="page-spinner__ring">
        <img src="/favicon.png" alt="" />
      </div>
    </div>
  );
}
